module.exports = __webpack_public_path__ + "img/card_ip_stipulation36.8566066f.svg";